import { getMonthsForLanguage } from "./LanguageDictionary";

// Dynamically generate birth year options: 100 years ago to 18 years ago
const currentYear = new Date().getFullYear();
export const dateOfBirthYearOptions: number[] = Array.from(
  { length: currentYear - 18 - (currentYear - 100) + 1 },
  (_, i) => currentYear - 100 + i
);

// returns the list of days depending on the month and year
const getDaysInMonth = (month: number, year: number): number[] => {
  // return all days in the month
  return Array.from({ length: new Date(year, month, 0).getDate() }, (_, i) => i + 1);
};

// returns the list of days depending on the month and year
export const getDaysForMonthName = (monthName: string, year: number, languageId: string): number[] => {
  // get the month number
  const monthNumber: number = getMonthsForLanguage(languageId)?.find((m) => m.name === monthName) ? +getMonthsForLanguage(languageId)?.find((m) => m.name === monthName)!.id ?? 1 : 1;
  // return all days in the month
  return getDaysInMonth(monthNumber, year);
};